import React from 'react';
import InputField, {
	type FieldProps as Props,
} from '../../common/ui/fields/base-fields/input-field';

const TextField = (props: Props) => <InputField type="text" {...props} />;

export default TextField;
export { mutateTextField } from './utils';
